import styled from "styled-components";
import { Table, TableRow } from "@material-ui/core";

export const DashboardTableContainer = styled.div`
  width: 40%;

  @media only screen and (max-width: 1049px) {
    width: 90%;
  }
`;

export const DashboardTableStyled = styled(Table)`
  min-width: 650px;
`;

export const TableHeaderText = styled.p`
  font-family: AvenirLTProBlack, sans-serif;
  font-size: 14px;
  font-weight: 200;
  color: var(--c7);
`;

export const TableBodyText = styled.p`
  font-family: AvenirLTProMedium, sans-serif;
  font-size: 14px;
  font-weight: 200;
  color: var(--c7);
`;

export const DashboardTableRow = styled(TableRow)`
  &:last-child td,
  &:last-child th {
    border: 0;
  }
`;
